export default __webpack_public_path__ + "static/media/direction-icon.98f6a06a.svg";